import React from 'react';
import PropTypes from 'prop-types';
import ChartComponent from './ChartComponent';

const BarChartComponent = ({
  data,
  series,
  labels,
  title,
  noTitle,
  noLegend,
  noXDisplay,
  yMin,
  yMax,
  ...passthruProps
}) => (
  <ChartComponent
    type="bar"
    data={{
      datasets: [{
        data,
        backgroundColor: series.map(s => s.colour),
        label: title
      }],
      labels: labels || series.map(s => s.label)
    }}
    options={{
      title: {
        display: !noTitle && title !== undefined,
        text: title
      },
      tooltips: { mode: 'x-axis' },
      hover: { intersect: false, },
      legend: { display: !noLegend, },
      scales: {
        yAxes: [{
          ticks: {
            min: yMin,
            max: yMax
          }
        }],
        xAxes: [{ display: !noXDisplay }]
      }
    }}
    panelOptions={passthruProps.panelOptions}
    {...passthruProps}
  />
);

BarChartComponent.propTypes = {
  data: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  series: PropTypes.arrayOf(PropTypes.shape({
    colour: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  })).isRequired,
  labels: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string,
  noTitle: PropTypes.bool,
  noLegend: PropTypes.bool,
  noXDisplay: PropTypes.bool,
  yMax: PropTypes.number.isRequired,
  yMin: PropTypes.number.isRequired,
  onClick: PropTypes.func
};

export default BarChartComponent;


// WEBPACK FOOTER //
// src/Components/BarChartComponent.jsx